import React from "react";
import { View, ActivityIndicator } from "react-native";
import { useFocusEffect } from "expo-router";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Colors } from "@/constants/Colors";
import useFinanceDataStore from "@/store/financeData";
import NetWorthChart from "@/components/myMoney/NetWorthChart";
import SpendChart from "@/components/myMoney/SpendChart";
import BudgetsCard from "@/components/myMoney/BudgetsCard";
import TransactionsCard from "@/components/myMoney/TransactionsCard";
import SubscriptionsCard from "@/components/myMoney/SubscriptionsCard";
import useWindow from "@/hooks/useWindow";
import FBTrackingService from "@/services/fbTrackingService";

export default function DashboardScreen() {
  const { financeData, isLoading } = useFinanceDataStore();
  const { isDesktop } = useWindow();

  useFocusEffect(
    React.useCallback(() => {
      FBTrackingService.trackViewContent("my-money-dashboard");
    }, [])
  );

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={Colors.primary} />
      </View>
    );
  }

  return (
    <View style={styles.content}>
      <View style={[styles.gap, isDesktop && { flexDirection: "row" }]}>
        <View style={{ flex: 1 }}>
          <NetWorthChart financeData={financeData} />
        </View>
        <View style={{ flex: 1 }}>
          <SpendChart financeData={financeData} />
        </View>
      </View>
      <View style={[styles.gap, isDesktop && { flexDirection: "row" }]}>
        <View style={[styles.gap, isDesktop && { flex: 1 }]}>
          <BudgetsCard financeData={financeData} />
          <TransactionsCard financeData={financeData} />
        </View>
        <View style={isDesktop && { flex: 1 }}>
          <SubscriptionsCard financeData={financeData} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    padding: 16,
    gap: 16,
    paddingBottom: 100,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.background,
  },
  gap: {
    gap: 16,
  },
});
